import { RoundIntegrityWatcher } from '../../../logger/RoundIntegrityWatcher';
import { betActions } from '../../../store/slices/bets/slice';
import type { IBetSpotValue, AcceptedBet, BetType } from '../../../store/slices/bets/types';
import { ChipTypes } from '../../../store/slices/chips/types';
import { CrossOriginCommunication } from '../../crossOriginCommunication/CrossOriginCommunicationController';
import { OutgoingMessage } from '../../crossOriginCommunication/types';
import type { GameCommunicationMessageType } from '../types';
import { MessageName } from '../types';

import { BaseBetGameCommunicationProcessor } from './BaseBetGameCommunicationProcessor';

export interface BetCommunicationMessageType extends GameCommunicationMessageType {
  amount: number;
  betcode: string; // could be a number in a string
  bettype: string;
  nc: number;
  externalMessageTrigger?: string; //recive data from operator
}

export class CoreBetGameCommunicationProcessor extends BaseBetGameCommunicationProcessor {
  public messageName = MessageName.Bet;
  public delay = 0;

  // TODO: maybe I should be renamed to something like 'GameCommunicationBetRestorationProcessor'?
  public process(message: BetCommunicationMessageType): void {
    RoundIntegrityWatcher.setHadBets();

    const { amount, betCode, nc, bettype, externalMessageTrigger } = this.extractMessageData(message);

    if (this.store.getState().gameState.isLoadedInActiveRound) {
      const acceptedBetRestored: AcceptedBet = {
        amount,
        betCode,
        errorCode: 0,
      };
      const betObj: IBetSpotValue = { value: amount };
      const bet: BetType = {
        betSpots: {
          [betCode]: {
            value: amount,
          },
        },
      };
      acceptedBetRestored.type = betObj.type = bettype as ChipTypes;
      if (bettype === ChipTypes.FreeChip) {
        acceptedBetRestored.count = betObj.count = nc;
      }
      bet.betSpots[betCode] = betObj;

      this.processActiveRound(acceptedBetRestored, bet);
    } else {
      this.processSubsequentRounds(betCode, amount, bettype as ChipTypes, nc);
    }
    if (externalMessageTrigger) {
      CrossOriginCommunication.dispatchWithDebounce(OutgoingMessage.ErrorMessage, {
        errorParameters: {
          errorData: externalMessageTrigger,
        },
      });
    }
  }

  public processActiveRound(acceptedBet: AcceptedBet, bet: BetType): void {
    const tableId = this.store.getState().config.session?.tableId ?? '';
    this.store.dispatch(betActions.pushAcceptedBet(acceptedBet));
    this.store.dispatch(betActions.updateBetStackHead(bet));
    this.store.dispatch(betActions.saveLastBets({ tableId }));
  }

  protected extractMessageData(message: BetCommunicationMessageType): {
    amount: number;
    betCode: number;
    bettype: string;
    externalMessageTrigger?: string;
    nc: number;
  } {
    return {
      amount: Number(message.amount),
      betCode: Number(message.betcode),
      bettype: String(message.bettype ?? ChipTypes.CasinoChip),
      nc: Number(message.nc),
      externalMessageTrigger: message?.externalMessageTrigger,
    };
  }

  protected processSubsequentRounds(betCode: number, amount: number, bettype: ChipTypes, nc: number): void {
    this.store.dispatch(betActions.updateAcceptedBet({ betCode, amount, bettype, nc, errorCode: 0 }));
    this.updateGameStatus();
  }
}
